import { createSelector } from 'reselect';
 
const selectLogs = (state: any) => state.logs;
 
export const selectLogsCurrentItem = createSelector([selectLogs], (logs) => logs.current);
 
export const selectLogsListItems = createSelector([selectLogs], (logs) => logs.list);
 
 
export const selectLogsItemById = (itemId: any) =>
    createSelector(selectLogsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));
 
export const selectLogsCreatedItem = createSelector([selectLogs], (logs) => logs.create);
 
export const selectLogsUpdatedItem = createSelector([selectLogs], (logs) => logs.update);
 
export const selectLogsReadItem = createSelector([selectLogs], (logs) => logs.read);
 
export const selectLogsDeletedItem = createSelector([selectLogs], (logs) => logs.delete);
 
export const selectLogsSearchedItems = createSelector([selectLogs], (logs) => logs.search);
 
export const selectLogsItemsCount = createSelector([selectLogs], (logs) => logs.count);
 
export const selectLogsItemsFilter = createSelector([selectLogs], (logs) => logs.filter);